<template>
  <div class="modal-container" @click.self.prevent="showView('main')">
    <button @click="setShowView('tagDetail')" class="pop-header-btn">
      <img src="../../assets/images/search/search-icon-layer-hashtag-22.png" alt=""/> 태그로 검색하기</button>
    <div v-if="statusView === 'popul'" class="sh-pop-body">
      <search-popular :isplayymovie="isplayymovie"/>
    </div>

    <div class="sh-pop-header">
      <div slot="pop-header">
        <div class="sh-pop-input-wrap">
          <label class="dsn" for="search-ip">검색어를 입력해 주세요</label>
          <input type="text" @keyup="getRealTimeList($event)"
                 @keydown.enter="setInputEnter($event)"
                 @focus.self.prevent="showView('history')"
                 class="sh-pop-input"
                 placeholder="검색어를 입력해 주세요"
                 id="search-ip"
                 autocomplete="off" >
          <div class="sh-pop-input-border"></div>
        </div>
      </div><!--pop-header//-->
    </div>

    <div class="sh-pop-body">
      <search-history v-if="statusView === 'history'" :historyList="historyList" :showView="setShowView" :getHistoryList="getHistoryList" />
      <search-realtime v-if="statusView === 'realTime'" :searchWord="searchWord" :realTimeList="realTimeList" />
    </div>

    <div class="sh-pop-footer">
      <div>
        <div class="search-popup-scroll-gradation"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchPopular from '@/components/search/SearchPopular'
import SearchHistory from '@/components/search/SearchHistory'
import SearchRealtime from '@/components/search/SearchRealtime'
import { getSearchInstanceKeywords } from '@/common/utils/request'
import _ from 'lodash'
import cookie from '@/common/utils/cookie'
import { removePrefixEmptyString, setSearchWordSave } from '@/common/utils/common'
import { CLOSE_SEARCH_POPUP_EVENT, SEARCH_HISTORY_LOCAL_STORAGE_KEY } from '@/common/resources/const'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'

export default {
  components: {
    SearchPopular, // 실시간 인기검색어
    SearchHistory, // 최근 검색어
    SearchRealtime // 실시간 검색
  },
  props: {
    statusView: {
      type: String
    },
    showView: {
      type: Function
    }
  },
  data () {
    return {
      searchWord: '', // 검색어
      historyList: [], // 최근검색어 리스트
      realTimeList: [], // 실시간 검색어 리스트
      pooqzoneInfo: cookie.getPooqZoneInfo(),
      isplayymovie: 'y' //
    }
  },
  methods: {
    // 실시간 검색어 조회
    getRealTimeList: _.debounce(function (event) { this.setRealTimeList(event) }, 200),
    setRealTimeList (event) {
      this.realTimeList = []
      this.searchWord = event.target.value
      this.showView('history', this.searchWord)
      if (!this.searchWord) {
        return
      }
      if (this.searchWord.length > 50) {
        alert('최대 50자까지 입력 가능합니다. 글자수를 확인해주세요.')
        this.searchWord = this.searchWord.substring(0, 48)
      }
      // 실시간 조회 mobile web 3.1도 이거 사용
      getSearchInstanceKeywords({ keyword: this.searchWord, isplayymovie: this.isplayymovie }).then(({ data }) => {
        const findItemEval = item => item.type === 'searchinfo' && this.searchWord === item.searchkeyword
        this.realTimeList = _.filter(data, findItemEval).length > 0 ? data : ''
      })
    },
    setInputEnter (event) {
      const keyword = removePrefixEmptyString(event.target.value)
      if (keyword.length === 0) { alert('검색어를 입력 하세요.'); return false }
      setSearchWordSave(keyword)
      this.$events.$emit(CLOSE_SEARCH_POPUP_EVENT)
      this.$router.push({
        name: PATH_NAME_SEARCH,
        query: { searchWord: keyword }
      })
    },
    setInputEventTriggerFireFox () {
      const agent = navigator.userAgent.toLowerCase()
      let self = this
      if (agent.indexOf('firefox') !== -1) {
        document.getElementById('search-ip').addEventListener('input', function (event) {
          self.getRealTimeList(event)
        })
      }
    },
    getHistoryList () {
      let history = localStorage.getItem(SEARCH_HISTORY_LOCAL_STORAGE_KEY)
      this.historyList = history ? history.split('&') : []
    },
    setShowView (val) {
      this.showView(val, this.searchWord)
    }
  },
  created () {
    this.getHistoryList()

    if (this.pooqzoneInfo && this.pooqzoneInfo.isPooqzone) {
      this.isplayymovie = this.pooqzoneInfo.isplayymovie
      console.log('searchPopupText isplayymovie >>>', this.pooqzoneInfo, this.pooqzoneInfo.isplayymovie)
    }
  },
  mounted () {
    this.setInputEventTriggerFireFox()
  }
}
</script>
<style lang="css" src="@/assets/css/search.css">
</style>
